import { render, staticRenderFns } from "./BettingPromotions.vue?vue&type=template&id=295cdb1e"
import script from "./BettingPromotions.vue?vue&type=script&lang=js"
export * from "./BettingPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports